import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { S25ButtonComponent } from "../../standalone/s25.button.component";
import { IngestionPoint } from "./data.ingestion.service";

@Component({
    selector: "s25-ng-ingestion-form-tile",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [S25ButtonComponent],
    host: { class: "form-card" },
    template: `
        <h4>{{ form().ingestionPointName }}</h4>
        @if (showOrganization()) {
            <p class="form-organization">Organization: {{ form().subCategoryName || "No organization" }}</p>
        }
        @if (form().description) {
            <p class="form-description">{{ form().description }}</p>
        }
        <s25-ng-button [type]="'primary'" [onClick]="emitFormStart" [onClickArgs]="[form().ingestionPointId!]">
            {{ actionLabel() }}
        </s25-ng-button>
    `,
    styles: `
        :host {
            display: block;
            border: 1px solid var(--color--border);
            border-radius: 8px;
            padding: 1.5rem;
            background-color: var(--color--surface-2-bg);
        }

        h4 {
            margin: 0 0 0.5rem 0;
            color: var(--cn-blue);
        }

        .form-organization {
            margin: 0 0 0.5rem 0;
            color: var(--color--text-muted);
            font-size: 0.95rem;
        }

        .form-description {
            margin: 0 0 1rem 0;
            color: var(--color--text-muted);
        }

        @media (max-width: 480px) {
            s25-ng-button {
                width: 100%;
            }
        }
    `,
})
export class IngestionFormTileComponent {
    readonly form = input.required<IngestionPoint>();
    readonly actionLabel = input("Start Form");
    readonly showOrganization = input(false);
    readonly formStart = output<number>();

    readonly emitFormStart = (ingestionPointId: number) => {
        this.formStart.emit(ingestionPointId);
    };
}
